import { __assign } from "tslib";
import * as React from 'react';
function FileIconUndefinedSizeS(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 21 28" }, props),
        React.createElement("path", { d: "M19.6 0H1.4A1.4 1.4 0 000 1.4v25.2A1.4 1.4 0 001.4 28h18.2a1.4 1.4 0 001.4-1.4V1.4A1.4 1.4 0 0019.6 0z" }),
        React.createElement("path", { d: "M14 10.64c0 .56-.027.98-.08 1.26-.053.267-.173.54-.36.82L11.04 15v2H9v-2.5l2.92-2.92c.053-.187.08-.44.08-.76v-.52c0-.413-.12-.733-.36-.96-.24-.227-.607-.34-1.1-.34H8V7h2.3c2.24 0 3.7 1 3.7 3v.64zM11 19v2H9v-2h2z", fill: "#fff" })));
}
export default FileIconUndefinedSizeS;
